// ngPostOrderCampaignKey
export const NG_TRACK_CAMPAIGN_KEY = 'nxg_order_tracking';
export const SHOW_NG_TRACK_VARIATION = 'nxg_trackorder';
export const PWA_WORKSPACE_ID = '10a2e2a7-f191-4bd8-a46d-89c64101f6fd';
export const MAIN_ACCOUNT_ID_XLABS = '28d1646c-6773-47ae-ba46-058d379786ce';
export const TENANT_ID_XLABS = '70bd4f5a-d870-41b0-9664-8242859ef1c6';